(function () {
  const BLOCK_TAG = 'no-rapi-subs';
  let running = false;
  let stripped = false;

  async function checkAndStrip() {
    if (running) return;
    running = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const subsItems = (cart.items || []).filter((i) => i.selling_plan_allocation);
      if (!subsItems.length) {
        running = false;
        return;
      }

      const handles = [...new Set(subsItems.map((i) => i.handle).filter(Boolean))];
      const products = await Promise.all(
        handles.map((h) =>
          fetch(`/products/${h}.js`)
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      );
      const blocked = products.some(
        (p) => p && Array.isArray(p.tags) && p.tags.includes(BLOCK_TAG)
      );
      if (!blocked) {
        running = false;
        return;
      }

      const codeApps = (cart.cart_level_discount_applications || []).filter(
        (d) => d.type === 'discount_code'
      );
      const hasItemCode = (cart.items || []).some((i) =>
        (i.discounts || []).some((d) => d.type === 'discount_code')
      );
      if (!codeApps.length && !hasItemCode) {
        running = false;
        return;
      }

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' }),
      });

      stripped = true;
      if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'subs-discount-guard',
        });
      }
      if (location.pathname === '/cart' || location.pathname === '/checkout') {
        location.reload();
      }
    } catch (err) {
      console.warn('[subs-discount-guard]', err);
    } finally {
      running = false;
    }
  }

  function wireCheckoutButtons() {
    const selectors = [
      'form[action="/checkout"] button[type="submit"]',
      'form[action="/checkout"] input[type="submit"]',
      'a[href*="/checkout"]',
      'button[name="checkout"]',
    ];
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      if (el.dataset.subsGuardBound) return;
      el.dataset.subsGuardBound = '1';
      el.addEventListener(
        'click',
        async (e) => {
          if (stripped) return;
          e.preventDefault();
          await checkAndStrip();
          window.location.href = '/checkout';
        },
        { once: true }
      );
    });
  }

  function init() {
    checkAndStrip();
    wireCheckoutButtons();
    if (window.PUB_SUB_EVENTS && typeof window.subscribe === 'function') {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => {
        stripped = false;
        checkAndStrip();
        setTimeout(wireCheckoutButtons, 200);
      });
    }
    const observer = new MutationObserver(() => wireCheckoutButtons());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
